import { courseConstants } from "../_constants/course.constants";
const coursesInitialState = {
  courses: [],
  currentPage: 0,
  totalPage: 0,
  total: 0,
};
const courseListInitialState = {
  all: coursesInitialState,
  drafts: coursesInitialState,
  isReview: coursesInitialState,
  published: coursesInitialState,
  archived: coursesInitialState,
};
const initialState = {
  courses: Object.assign({}, courseListInitialState),
  purchasedCourses: Object.assign({}, courseListInitialState),
  myCourses: Object.assign({}, courseListInitialState),
  viewAwardCourse: Object.assign({}, courseListInitialState),
};
const Tabs = {
  ALL: "all",
  DRAFT: "draft",
  INREVIEW: "isReview",
  PUBLISHED: "published",
  ARCHIEVED: "archived",
};
export function course(state = initialState, action) {
  switch (action.type) {
    case courseConstants.FETCH_START:
      return {
        ...state,
        isFetching: true,
      };
    case courseConstants.FETCH_END:
      return {
        ...state,
        isFetching: false,
      };
    case courseConstants.SET_COURSES: {
      const { courses, currentPage, totalPage, total } = action.payload;
      return {
        ...state,
        courses: {
          [Tabs.ALL]: {
            courses: [
              ...new Set([
                ...(state.courses[Tabs.ALL]?.courses ?? []),
                ...(courses ?? []),
              ]),
            ],
            currentPage: currentPage,
            totalPage: totalPage,
            total: total,
          },
        },
        isFetching: false,
      };
    }

    case courseConstants.RESET_COURSELIST: {
      const { courses, currentPage, totalPage, isFetching } = action.payload;
      return {
        ...state,
        courses: {
          [Tabs.ALL]: {
            courses: courses,
            currentPage: currentPage,
            totalPage: totalPage,
          },
        },
        isFetching: isFetching,
      };
    }
    case courseConstants.MY_COURSE_LIST:
      const { key, courses, currentPage, totalPage, total } = action.payload;
      return {
        ...state,
        myCourses: {
          ...state.myCourses,
          [key]: {
            courses: [
              ...new Set([
                ...(state.myCourses[key]?.courses ?? []),
                ...(courses ?? []),
              ]),
            ],
            currentPage: currentPage,
            totalPage: totalPage,
            total: total,
          },
        },
        isFetching: false,
      };

    case courseConstants.RESET_MY_COURSELIST: {
      const { key, courses, currentPage, totalPage } = action.payload;
      return {
        ...state,
        myCourses: {
          ...state.myCourses,
          [key]: {
            courses: courses,
            currentPage: currentPage,
            totalPage: totalPage,
          },
        },
        isFetching: false,
      };
    }

    case courseConstants.SET_RESET_PURCHASED_COURSES: {
      const { courses, currentPage, totalPage } = action.payload;
      return {
        ...state,
        purchasedCourses: {
          [Tabs.ALL]: {
            courses: courses,
            currentPage: currentPage,
            totalPage: totalPage,
          },
        },
        isFetching: false,
      };
    }

    case courseConstants.SEARCH_COURSES:
      return {
        ...state,
        searchResults: action.payload,
      };
    case courseConstants.SET_PURCHASED_COURSES: {
      const { courses, currentPage, totalPage } = action.payload;
      return {
        ...state,
        purchasedCourses: {
          [Tabs.ALL]: {
            courses: [...state.purchasedCourses[Tabs.ALL].courses, ...courses],
            currentPage: currentPage,
            totalPage: totalPage,
          },
        },
        isFetching: false,
      };
    }
    case courseConstants.SET_VIEW_AWARDS: {
      const { courses, currentPage, totalPage } = action.payload;
      return {
        ...state,
        viewAwardCourse: {
          [Tabs.ALL]: {
            courses: [...state.viewAwardCourse[Tabs.ALL].courses, ...courses],
            currentPage: currentPage,
            totalPage: totalPage,
          },
        },
        isFetching: false,
      };
    }
    default:
      return state;
  }
}
